import { NewsDesignToken } from '../news';
import { RiffDesignTokenV2 } from '../riff';

export const LightTheme = {
  riff: RiffDesignTokenV2.color.light,
  news: NewsDesignToken.color.light,
  palette: {}
} as const;
